<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="action-bar">
        <input 
          type="text" 
          class="form-control search-input" 
          placeholder="Search by Name..." 
          v-model="searchQuery" 
        />
        <button type="button" class="btn button-default new-item-btn" @click="newStaff">
          Add New Staff
        </button>
      </div>

      <!-- added by isindu | 2025/ 12/ 02 -->
      <div v-if="loading" class="loading-spinner">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>

      <!-- added v-else by isindu | 2025/ 12/ 02 -->
      <table v-else class="table">
        <thead>
          <tr class="border-bottom-primary">
            <th scope="col">Name</th>
            <th scope="col">Type</th>
            <th scope="col">Status</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="staff in filteredStaff" :key="staff.id">
            <td>{{ staff.name }}</td>
            <td>{{ staff.staf_type }}</td>
            <td>
              <span :class="staff.is_active === '1' ? 'badge badge-active' : 'badge badge-cancel'">
                {{ staff.is_active === '1' ? 'ACTIVE' : 'INACTIVE' }}
              </span>
            </td>
            <td>
              <i class="fa fa-edit" @click="editStaff(staff.id)"></i>
              <i class="fa fa-eye action-icon" aria-hidden="true" @click="viewStaff(staff.id)"></i>
            </td>
          </tr>

          <tr v-if="!filteredStaff.length">
            <td colspan="4" class="text-center no-data">No staff found.</td>
          </tr>
        </tbody>
      </table>

      <!-- Use the separate modal component -->
      <ViewDistributorStaff :show="showModal" :staff-id="selectedStaffId" @close="closeModal" />
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { fetchAllStaffList } from "@/services/dataService";
import ViewDistributorStaff from "@/pages/Modal/ViewDistributorStaff.vue"; // Adjust path as needed


export default {
  name: 'DistributorStaff',
  components: {
    ViewDistributorStaff
  },
  data() {
    return {
      token: localStorage.getItem('token_set'),
      companyId: localStorage.getItem('company_id'),
      profileId: localStorage.getItem('profile_id'),
      reportingProfileId: localStorage.getItem('reportingL1ProfileId'),
      userCategory: localStorage.getItem('user_label'),
      router: useRouter(),
      loading: false,
      staffList: [],
      searchQuery: "",
      showModal: false,
      selectedStaffId: null
    }
  },

  computed: {
    filteredStaff() {
      if (!this.searchQuery) {
        return this.staffList;
      }
      const query = this.searchQuery.toLowerCase();
      return this.staffList.filter(staff => 
        (staff.name || "").toLowerCase().includes(query)
      );
    }
  },

  created() {
    this.fetchStaff();
  },

  watch: {
    showModal(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    }
  },

  methods: {
    async fetchStaff() {
      this.loading = true;
      try {
        let idToUse = this.profileId;
        if (this.userCategory === 'DISTRIBUTOR BACK OFFICE') {
          idToUse = this.reportingProfileId;
        }
        const response = await fetchAllStaffList(idToUse, this.token);
        this.staffList = response.data.data || [];
      } catch (error) {
        console.error("Error fetching staff list:", error);
        this.staffList = [];
      } finally {
        this.loading = false;
      }
    },

    viewStaff(id) {
      this.selectedStaffId = id;
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.selectedStaffId = null;
      document.body.style.overflow = 'auto'; // Ensure scroll is restored
    },

    newStaff() {
      this.router.push({ path: "/new-staff" });
    },

    editStaff(id) {
      this.router.push({ path: `/edit-staff/${id}` });
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  padding: 10px;
}

.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 15px;
}

.search-input {
  max-width: 300px;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  width: 100%;
}

.search-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

.new-item-btn {
  margin: 0;
  padding: 10px 20px;
}

.fa-eye {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
  margin-left: 5px;
}

.fa-eye:hover {
  color: #0056b3;
  transform: scale(1.2);
}

.fa-eye:active {
  transform: scale(1.1);
}

.fa-edit {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
}

.fa-edit:hover {
  color: #0056b3;
  transform: scale(1.2);
}

.fa-edit:active {
  transform: scale(1.1);
}

.badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 5px;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 80px;
  max-width: 80px;
}

.badge-active {
  background-color: #28a745;
}

.badge-cancel {
  background-color: #dc3545;
}

// added by isindu | 2025/ 12/ 02
.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin: 20px 0;
  color: #007bff;
}

.no-data {
  color: #888;
  padding: 20px 0;
}
</style>